import { render, staticRenderFns } from "./AppSupportManagement.vue?vue&type=template&id=33c2a027&scoped=true&"
import script from "./AppSupportManagement.vue?vue&type=script&lang=js&"
export * from "./AppSupportManagement.vue?vue&type=script&lang=js&"
import style0 from "./AppSupportManagement.vue?vue&type=style&index=0&id=33c2a027&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c2a027",
  null
  
)

export default component.exports